<template>
	<div
		ref="listRef"
		class="box relative flex w-full min-h-[56px]"
		:class="[
			profileField == true
				? ''
				: 'md:max-w-[25%] pl-0 sm:pl-4 md:pl-6 pr-0 sm:pr-4 pb-2 md:pb-0 pt-3 md:pt-0 border-t-[1px] border-b-[1px] border-gray-light md:border-0',
		]"
	>
		<div @click="showList = !showList" class="flex flex-col flex-1 w-[calc(100%-30px)] cursor-pointer">
			<span class="pb-1 text-dj-gray-dark text-sm font-medium">
				<template v-if="label && label.length > 0">{{ label }}</template>
				<template v-else>{{ $t("jobs.detailedSearchbar.level.title") }}</template>
			</span>
			<span
				v-if="selectedLevels.length"
				class="block w-[calc(100%-6px)] whitespace-nowrap overflow-ellipsis overflow-hidden"
			>
				{{ selectedLevels.map((level) => level.name[locale]).join(", ") }}
			</span>
			<span v-else class="text-dj-gray">{{ placeholder }}</span>
		</div>

		<DropdownButton v-model="showList" class="mt-2" />

		<div
			v-if="showList"
			class="absolute p-5 left-0 top-[60px] md:top-[85px] w-[240px] max-w-[100%] md:max-w-[100vw] h-[max] bg-white border border-dj-gray-light rounded-big flex flex-col gap-y-[10px] z-30"
		>
			<BaseCheckbox
				v-for="(level, index) in levels"
				:key="index"
				v-model="level.value"
				@change="onChangeLevel(level)"
			>
				{{ level.name[locale] }}
			</BaseCheckbox>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent, type PropType, ref, watch } from "vue";
import { onClickOutside } from "@vueuse/core";
import { useI18n } from "vue-i18n";
import axios from "axios";

export default defineComponent({
	name: "SearchbarJobsDetailedLevel",
	props: {
		modelValue: {
			type: Array as PropType<number[]>,
			required: true,
		},
		placeholder: {
			type: String,
			default: "",
		},
		label: {
			type: String,
			default: "",
		},
		profileField: {
			type: Boolean,
			default: false,
		},
	},
	emits: ["update:modelValue"],
	async setup(props, { emit }) {
		const { locale } = useI18n();

		onMounted(() => {
			const filterScope = props.profileField == false ? "&scope[hasAttached]" : "";

			axios(globalConfig.API + "/tags?type[]=job-level" + filterScope).then((response) => {
				if (globalConfig.isBlue) {
					response.data.data.forEach(function (level, index) {
						if (!["junior", "medior", "senior"].includes(level.slug)) {
							response.data.data.splice(index, 1);
						}
						if (response.data.data[index] != undefined) {
							if ("junior" == response.data.data[index].slug)
								response.data.data[index].name.hu = "1-3 év tapasztalat";
							if ("medior" == response.data.data[index].slug)
								response.data.data[index].name.hu = "3-5 év tapasztalat";
							if ("senior" == response.data.data[index].slug)
								response.data.data[index].name.hu = "5+ év tapasztalat";
						}
					});
				}
				levelsData.value = response.data;
				addValuePropToLevels();

				if (props.profileField == false) {
					getValuesFromUrl();
				}
				if (props.profileField == true) {
					getValuesFromVModel();
				}
			});
		});

		const levelsData = ref();
		const route = useRoute();

		watch(
			() => props.modelValue,
			(value) => {
				if (value.length == 0) {
					selectedLevels.value = [];

					levels.value.forEach((level) => {
						level.value = false;
					});
				}
			}
		);

		// Check the url parameters and set value if given
		watch(
			() => route.query,
			(value) => {
				if (value && value.level != undefined) {
					addValuePropToLevels();
					getValuesFromUrl();
					emitLevels();
				}
			}
		);

		const levels = ref([]);

		function addValuePropToLevels() {
			levels.value = levelsData.value.data.map((level) => {
				return {
					...level,
					value: false,
				};
			});
		}

		const selectedLevels = ref([]);

		function onChangeLevel(level) {
			const index = levels.value.findIndex((pred) => pred.name[locale.value] == level.name[locale.value]);
			if (levels.value[index].value) {
				selectedLevels.value.push(level);
				emit(
					"update:modelValue",
					selectedLevels.value.map((level) => level.id)
				);
			} else {
				selectedLevels.value = selectedLevels.value.filter(
					(sLevel) => sLevel.name[locale.value] != level.name[locale.value]
				);
				emit(
					"update:modelValue",
					selectedLevels.value.map((level) => level.id)
				);
			}
		}

		function getValuesFromUrl() {
			const query = route.query;

			if (query.level) {
				const levelsFromUrl = query.level
					.toString()
					.split(",")
					.map((t) => Number.parseInt(t));

				levels.value.forEach((type, index) => {
					levelsFromUrl.forEach((levelFU) => {
						if (type.id == levelFU) {
							levels.value[index].value = true;
							if (
								selectedLevels.value.filter((level) => level.id == levels.value[index].id).length == 0
							) {
								selectedLevels.value.push(levels.value[index]);
							}
						}
					});
				});

				emitLevels();
			}
		}

		function getValuesFromVModel() {
			levels.value.forEach((level, index) => {
				if (props.modelValue.includes(level.id)) {
					levels.value[index].value = true;
					if (selectedLevels.value.filter((level) => level.id == levels.value[index].id).length == 0) {
						selectedLevels.value.push(levels.value[index]);
					}
				}
			});
		}

		function emitLevels() {
			emit(
				"update:modelValue",
				selectedLevels.value.map((level) => level.id)
			);
		}

		const showList = ref(false);
		const listRef = ref(null);

		onClickOutside(listRef, () => {
			showList.value = false;
		});

		return {
			locale,
			levels,
			selectedLevels,
			showList,
			listRef,
			onChangeLevel,
		};
	},
});
</script>
